import * as React from 'react';

import { BoxProps, makeUclComponent } from '@rbilabs/universal-components';

import { QuestBadgeIcon, QuestBadgeText, QuestBadgeWrapper } from './styled';

type QuestBadgeProps = BoxProps & { text?: string };

export const QuestBadge = makeUclComponent<QuestBadgeProps>(({ text, ...props }) => {
  if (!text) {
    return null;
  }

  return (
    <QuestBadgeWrapper
      flexDirection="row"
      alignItems="center"
      padding="$1.5"
      borderRadius="sm"
      alignSelf="flex-start"
      shadow={2}
      {...props}
    >
      <QuestBadgeIcon marginRight="$1.5" />
      <QuestBadgeText variant="copyTwo">{text}</QuestBadgeText>
    </QuestBadgeWrapper>
  );
});
